import React from "react";
import { FiPlus } from "react-icons/fi";
import JoditEditor from "jodit-react";

export default function Step1SectionMeta({
  sectionData,
  setSectionData,
  onNext,
}) {
  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
        <InputGroup
          label="Section Name"
          placeholder="e.g. Logical Reasoning"
          value={sectionData.sectionName}
          onChange={(e) =>
            setSectionData({ ...sectionData, sectionName: e.target.value })
          }
        />

        <div className="flex flex-col gap-2 mt-4">
          <span className="text-sm font-bold text-gray-600 ml-1">
            Section Paragraph
          </span>

          <div className="flex bg-gray-100 rounded-xl p-1 w-fit">
            <button
              type="button"
              onClick={() =>
                setSectionData((prev) => ({
                  ...prev,
                  paragraph: { ...prev.paragraph, isParagraph: false },
                }))
              }
              className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${
                !sectionData.paragraph.isParagraph
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-gray-500 hover:bg-gray-200"
              }`}
            >
              No Paragraph
            </button>

            <button
              type="button"
              onClick={() =>
                setSectionData((prev) => ({
                  ...prev,
                  paragraph: { ...prev.paragraph, isParagraph: true },
                }))
              }
              className={`px-4 py-2 rounded-lg text-sm font-bold transition-all ${
                sectionData.paragraph.isParagraph
                  ? "bg-blue-600 text-white shadow-sm"
                  : "text-gray-500 hover:bg-gray-200"
              }`}
            >
              Has Paragraph
            </button>
          </div>
        </div>

        <div className="sm:col-span-2">
          <InputGroup
            label="Initial Total Questions"
            type="number"
            value={sectionData.totalQuestions}
            onChange={(e) =>
              setSectionData({
                ...sectionData,
                totalQuestions: parseInt(e.target.value) || 0,
              })
            }
          />
        </div>
      </div>

      {sectionData.paragraph.isParagraph && (
        <div className="mt-4">
          <label className="block mb-2 font-semibold">Paragraph Content</label>

          <JoditEditor
            value={sectionData.paragraph.text}
            onChange={(newContent) =>
              setSectionData((prev) => ({
                ...prev,
                paragraph: {
                  ...prev.paragraph,
                  text: newContent,
                },
              }))
            }
          />
        </div>
      )}

      <button
        onClick={onNext}
        className="w-full py-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg flex items-center justify-center gap-2 text-sm md:text-base active:scale-[0.98]"
      >
        Configure {sectionData.totalQuestions} Questions <FiPlus />
      </button>
    </div>
  );
}

function InputGroup({ label, ...props }) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-bold text-gray-600 ml-1">{label}</label>
      <input
        {...props}
        className="px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none bg-white text-gray-700 text-sm md:text-base"
      />
    </div>
  );
}
